import { grayscale } from "./grayscale";
import { material } from "./material";
import { clean } from "./clean";
export * from "./types";
export const VictoryTheme = {
  grayscale,
  material,
  clean
};